<template>
    <div class="graduationDel">
        <div class="menu">
            <h4>提交历史</h4>
            <el-collapse accordion>
              <el-collapse-item v-for="(item,index) in data" :key="index" :title="item.title">
                <div class="item" v-for="(itemToo,indexToo) in item.paperStudent" :key="itemToo.id" >
                  <div class="item-title">
                    <div class="item-title_text" @click="handleNodeClick(itemToo)">
                      <div>历史{{(indexToo + 1)}} - </div>
                      <div :class="{active:itemToo.is_adopt == 2}"> {{itemToo.is_adopt | status}}</div>
                    </div>
                  </div>
                  <div class="item-p" v-if="itemToo.is_adopt == 2">
                    <span>驳回原因：</span><div v-html="itemToo.content"></div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
        </div>
        <div class="box">
            <i class="el-icon-arrow-left" size="20" @click="$base.goReturn()"></i>
            <h4>论文展示区</h4>
            <template v-if="wordSrc == ''">
                <div class="box-span">请选择论文</div>
            </template>
            <template v-else>
                <div class="box-loading" v-loading="loading" v-if="loading"></div>
                <div class="box-content" v-else>
                    <div id="wordView" v-html="wordSrc"></div>
                </div>
            </template>

        </div>


    </div>
</template>

<script>
import { getPaperVtpApi } from "@/api/basic";

import mammoth from 'mammoth';
export default {
    name: 'GraduationDel',
    data() {
        return {
            id:"",
            activeNames: [],
            data:[],
            defaultProps: {
                children: 'paperStudent',
                label: 'title'
            },
            current:{},
            wordSrc:'',
            loading:false
        };
    },
    filters:{
      status(val){
        if(val==0){
          return '待审核';
        }else if(val==1){
          return '审核通过';
        }else{
          return '审核不通过';
        }
      }
    },
  created(){
        this.id = this.$route.query.id;
        this.getData();
    },
    mounted(){
    },
    methods:{

        async getData(){
            const params = {id:this.id};
            const res = await getPaperVtpApi(params);
            if(res.code != 200)return;
            res.result.map(item => {
                item.paperStudent.map((itemToo, index) => {
                    let status = '';
                    switch (itemToo.is_adopt) {
                        case 0:
                            status = '待审核';
                            break;
                        case 1:
                            status = '审核通过';
                            break;
                        case 2:
                            status = '审核不通过';
                            break;
                    }
                    itemToo.title = '历史'+ (index + 1) + '-' + status;
                });
            });
            this.data = res.result;
        },

        handleNodeClick(data) {
            this.loading = true;
            this.current = data;
            // let str = 'https://view.officeapps.live.com/op/view.aspx?src=';
            // this.wordSrc = str + data.paper_url;
            this.getWordText(data.paper_url);
            // let a = setTimeout(()=>{this.loading = false;clearTimeout(a);}, 500);
        },

        getWordText(iUrl) {
            const xhr = new XMLHttpRequest();
            xhr.open("get", iUrl, true);
            xhr.responseType = "arraybuffer";
            xhr.onload = () => {
                if (xhr.status == 200) {
                    mammoth.convertToHtml({arrayBuffer: new Uint8Array(xhr.response)}).then((resultObject) => {
                        this.$nextTick(() => {
                            this.wordSrc = resultObject.value;
                            let a = setTimeout(()=>{this.loading = false;clearTimeout(a);}, 500);
                        });
                    });
                }
            };
            xhr.send();
        },
    }

};
</script>

<style lang="scss">
.graduationDel{
    display: flex;
    margin: 20px;
    height: calc(100vh - 200px);
    background: #fff;
    .menu{
        border-right: 1px solid #cccccc;
        padding: 0 20px;
        width: 280px;
        h4{
            font-size: 18px;
            line-height: 60px;
            font-weight: 400;
            margin: 0;
            border-bottom: 1px solid #cccccc;
        }
        .item{
            &-title{
              display: flex;
              &_text{
                display: flex;
                flex: 1;
                cursor: pointer;
                .active{
                  color: #f26362;
                }
              }
            }
            &-p{
              display: flex;
              padding-bottom: 20px;
              color: #ECA722;
              span{
                width: 80px;
              }
              div{
                flex: 1;
                word-break:break-all;
              }
            }
        }
    }
    .box{
        flex: 1;
        position: relative;
        .el-icon-arrow-left{
          position: absolute;
          left: 20px;
          top: 20px;
          cursor: pointer;
          font-size: 24px;
        }
        h4{
            font-size: 18px;
            line-height: 60px;
            font-weight: 400;
            text-align: center;
            margin: 0;
        }
        &-span{
            line-height: 60px;
            color: #909399;
            font-size: 14px;
            padding: 0 20px;
        }
        &-loading{
            height: calc(100vh - 150px - 140px);
        }
        &-content{
            height: calc(100vh - 150px - 140px);
            padding: 0 20px;
            #wordView{
                height: 100%;
                overflow-y: auto;
                iframe{
                    border: 0;
                }
            }
        }
        &-btns{
            padding: 20px;
        }
    }
}
</style>
